'use client';

import { useEffect, useRef } from 'react';

import { parsePurchaseParams, trackMetaEvent } from '@/lib/meta-pixel/fbq';

const SIGNUP_COOKIE = 'leva_fb_signup';

/**
 * Fires the two cross-redirect conversion events, once per full page load:
 *  - CompleteRegistration when the one-time leva_fb_signup cookie is present
 *    (set by the Google return handler for new accounts), then clears it.
 *  - Purchase when the Xendit return URL carries value + kind, then strips those
 *    params so a refresh cannot refire.
 */
export function MetaPixelEvents() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    if (document.cookie.split('; ').some((c) => c === `${SIGNUP_COOKIE}=1`)) {
      trackMetaEvent('CompleteRegistration', { method: 'google' });
      document.cookie = `${SIGNUP_COOKIE}=; Max-Age=0; path=/`;
    }

    const purchase = parsePurchaseParams(new URLSearchParams(window.location.search));
    if (purchase) {
      trackMetaEvent('Purchase', {
        value: purchase.value,
        currency: 'IDR',
        content_name: purchase.kind,
      });
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  return null;
}
